import { ValueOrDots } from "../../../components/exportWord/partials";
import TextUnderline from "../../../components/TextUnderline";
import { GENDER_VARIABLE } from "../../../constants/moduleConsts";

const TemplateNangLuongTruocHan = (props: any) => {
  const { data } = props;
  const gioiTinh = (data as any).gender === GENDER_VARIABLE.MALE ? "ông" : (data as any).gender === GENDER_VARIABLE.FEMALE ? "bà" : "ông/bà"

  return (
    <div className="word spaces px-70 colors-word">
      <div className="spaces text-center flex flex-between">
        <div className="fs-lg">
          <p>{data?.soYTeHeader ?? ""}</p>
          <p className="fw-600 text-uppercase">
            <span className="header-underline fs-lg">
              <ValueOrDots className="fs-lg" value={data.donViCongTacText} size={70} />
            </span>
          </p>
          <p className="spaces mt-16 fs-md">
            Số: <ValueOrDots size={10} value={data.soQuyetDinh} />/QĐ-<ValueOrDots value={data.tenVietTat} />
          </p>
        </div>
        <div className="fw-600 fs-lg">
          <p>CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
          <p>
            <span className="header-underline fs-lg">Độc lập - Tự do - Hạnh phúc</span>
          </p>
          <p className="spaces mt-16 fw-500 fs-md">
            <ValueOrDots value="" size={20} />, ngày <ValueOrDots value={data.ngayKyToTrinh ? new Date(data.ngayKyToTrinh).getDate() : ""} size={10} /> tháng{" "}
            <ValueOrDots value={data.ngayKyToTrinh ? new Date(data.ngayKyToTrinh).getMonth() + 1 : ""} size={10} /> năm{" "}
            <ValueOrDots value={data.ngayKyToTrinh ? new Date(data.ngayKyToTrinh).getFullYear() : ""} size={15} />
          </p>
        </div>
      </div>
      <div className="text-center fs-lg fw-600">
        <p>QUYẾT ĐỊNH</p>
        <p>
          <span className="header-underline fs-lg">Về việc nâng bậc lương trước thời hạn do lập thành tích xuất sắc
            cho cán bộ, viên chức
          </span>
        </p>
        <p className="spaces mt-16 text-uppercase">
          GIÁM ĐỐC <ValueOrDots className="fs-lg" value={data.donViCongTacText} size={70} />
        </p>
      </div>
      <div className="text-indent-40 text-italic text-justify">
        <p>{data?.qdThanhLap ?? ""}</p>
        <p>
          {data?.ttNangBacLuong || `Căn cứ Thông tư số 08/2013/TT-BNV ngày 31/7/2013 của Bộ Nội vụ hướng dẫn thực hiện chế độ nâng bậc lương
          thường xuyên và nâng bậc lương trước thời hạn đối với cán bộ, công chức, viên chức và người lao động; Thông tư
          số 03/2021/TT-BNV ngày 29/6/2021 của Bộ Nội vụ sửa đổi, bổ sung chế độ nâng bậc lương thường xuyên, nâng bậc
          lương trước thời hạn và chế độ phụ cấp thâm niên vượt khung đối với cán bộ, công chức và người lao động;`
          }
        </p>
        <p>{data?.ttNangBacLuongVK ?? ""}</p>
        <p>{data?.qdhdNangLuong ?? ""}</p>
        <p>{data?.canCuNangLuongBenhVien ?? ""}</p>
        <p>
          Căn cứ Kết quả họp Hội đồng xét duyệt nâng lương <ValueOrDots value={data.donViCongTacText} size={70} /> ngày{" "}
          <ValueOrDots value={data.ngayQuyetDinh} />;
        </p>
        <p>Theo đề nghị của Trưởng phòng Tổ chức hành chính Bệnh viện.</p>
      </div>

      <div className="spaces mt-16">
        <p className="fs-lg fw-600 text-center">QUYẾT ĐỊNH:</p>
        <div className="text-indent-40">
          <p>
            <span className="fw-600">Điều 1.</span> Nâng bậc lương thường xuyên đối với {gioiTinh} {" "}
            <span className="fw-600 text-capitalize">
              <ValueOrDots value={data.fullName} />
            </span>
            {data.birthdate ?
              (<>, sinh ngày <ValueOrDots value={data.birthdate} /></>)
              : data.namSinh ?
                (<>, sinh năm <ValueOrDots value={data.namSinh} /></>)
                :
                (<>, sinh ngày <ValueOrDots value={data.birthdate} /></>)

            }
            , <ValueOrDots value={data?.chucDanhText} /> <ValueOrDots value={data?.phongBanText} /> như sau:
          </p>
          <div className="spaces pl-40">
            <TextUnderline readOnly label="- Chức danh nghề nghiệp" value={data.chucDanhText} />
            <TextUnderline readOnly label="- Mã số chức danh" value={data.chucDanhCode || data.maChucDanh} />
          </div>
          <p>
            - Hiện hưởng bậc lương: <ValueOrDots value={data.beforeBacLuong || data.bacLuongHienHuong} size={10} />
            {data.beforeTotalBacLuong && <>/<ValueOrDots value={data.beforeTotalBacLuong} size={10} /></>}, Hệ số:{" "}
            <ValueOrDots value={data.beforeHeSoBacLuong || data.heSoLuongHienHuong} size={10} />
          </p>
          <p>- Thời gian xếp lương: <ValueOrDots value={data.beforeNgayHuongLuongTuNgay || data.thoiDiemXepLuong} /></p>
          <p>
            - Lên bậc lương mới: <ValueOrDots value={data.currentBacLuong || data.bacLuongMoi} size={10} />
            {data.currentTotalBacLuong && <>/ <ValueOrDots value={data.currentTotalBacLuong} size={10} /></>}
            , Hệ số:{" "} <ValueOrDots value={data.currentHeSoBacLuong || data.heSoLuongMoi} size={10} />
          </p>
          <p>- Thời gian tính nâng bậc lương lần sau kể từ ngày:  <ValueOrDots value={data.currentNgayHuongLuongTuNgay || data.thoiDiemXepLuongLanSau} /></p>
          <p>
            <span className="fw-600">Điều 2.</span> Quyết định này có hiệu lực kể từ ngày ký.
            <p>Các ông, bà: Trưởng phòng Tổ chức Hành chính; Trưởng phòng Tài chính
              kế toán; Trưởng, phó khoa, phòng có liên quan và {gioiTinh}{" "}
              <span className="text-capitalize">
                <ValueOrDots value={data.fullName} />
              </span>{" "}
              căn cứ thi hành Quyết định này kể từ ngày ký.
            </p>
          </p>
        </div>
      </div>
      <div className="flex flex-between spaces mt-16 align-start">
        <div>
          <p className="fw-600 text-italic">Nơi nhận: </p>
          <p>- Như Điều 2 (để t/h);</p>
          <p>- Lưu: TCHC, VT.</p>
        </div>
        <div className="fw-600 fs-lg text-center spaces pr-20">
          <p>GIÁM ĐỐC</p>
          <p className="spaces mt-70">
            <ValueOrDots value={data.nguoiQuyetDinhText} size={60} />
          </p>
        </div>
      </div>
    </div>
  );
}

export default TemplateNangLuongTruocHan;